import { Button } from '@mui/material';
import { useState } from 'react';

import { ButtonBox } from '../../../../../../components/UI/Box';
import {
  isRichTextEmpty,
  RichTextEditor,
} from '../../../../../Announcements/components/RichTextEditor';

interface CommentComposerProps {
  submitting: boolean;
  onSubmit: (body: string) => Promise<boolean>;
}

export function CommentComposer({
  submitting,
  onSubmit,
}: CommentComposerProps): JSX.Element {
  const [body, setBody] = useState('');
  // O `value` do RichTextEditor é só o conteúdo INICIAL: o tiptap não observa a
  // prop depois de montar (quem faz isso é o RichTextViewer, com setContent).
  // Zerar o estado não limparia o editor, então a key remonta o componente —
  // que também reseta o contador de caracteres.
  const [editorKey, setEditorKey] = useState(0);

  const isEmpty = isRichTextEmpty(body);

  const handleSubmit = (): void => {
    onSubmit(body).then((ok) => {
      // Só limpa quando salvou; erro preserva o texto para nova tentativa.
      if (!ok) return;
      setBody('');
      setEditorKey((key) => key + 1);
    });
  };

  return (
    <>
      <RichTextEditor
        key={editorKey}
        value={body}
        onChange={setBody}
        placeholder="Escreva uma observação sobre esta empresa"
        charLimit={3000}
      />
      <ButtonBox my={2}>
        <Button
          sx={{ width: '200px', height: '48px' }}
          disabled={submitting || isEmpty}
          onClick={handleSubmit}
        >
          comentar
        </Button>
      </ButtonBox>
    </>
  );
}
